module.exports = __webpack_public_path__ + "static/img/logo.355278af.png";